import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=3efe78e7&scoped=true"
import script from "./ToolbarItem.vue?vue&type=script&lang=ts"
export * from "./ToolbarItem.vue?vue&type=script&lang=ts"
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&id=3efe78e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe78e7",
  null
  
)

export default component.exports